import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dues"
export default class extends Controller {
  connect() {
  }

  setStatus(e) {
    e.preventDefault()
    let form = e.currentTarget.closest('form')
    let path = form.action;
    let params = $(form).serialize()
    // console.log(path, $(form).serialize());

    $.ajax({
      type: "PATCH",
      url: path,
      data: params,
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        if(data.status != 200){
          alert("Error Saving User")
        }
      }
    })

    console.log("setstatus", e.currentTarget.value)
  }
}
